import Link from "./Link";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <Link to="/" className="logo logo-footer">
              <span className="logo-symbol">*</span>
              <span className="logo-text">Orchid<em> Salon</em></span>
            </Link>
            <p>
              A premium beauty sanctuary in Bengaluru offering world-class services exclusively for women -
              where every visit is a celebration.
            </p>
            <p className="footer-tagline"><em>Salon / Academy / Exclusively for Ladies.</em></p>
          </div>

          <div className="footer-contact">
            <h4>Contact</h4>
            <ul>
              <li><strong>Visit Us</strong><span>Orchid Salon & Academy, Bengaluru, Karnataka, India</span></li>
              <li><strong>Call or WhatsApp</strong><a href="tel:+91XXXXXXXXXX">+91 XXXXX XXXXX</a></li>
              <li><strong>Email Us</strong><a href="mailto:hello@orchidsalon.in">hello@orchidsalon.in</a></li>
              <li><strong>Studio Hours</strong><span>Mon-Sat: 10 AM - 8 PM / Sun: 11 AM - 6 PM</span></li>
            </ul>
          </div>

          <div className="footer-newsletter">
            <h4>Newsletter</h4>
            <p>Beauty notes, service updates, and early access to academy programs.</p>
            <form className="newsletter-form" onSubmit={(event) => event.preventDefault()}>
              <input type="email" placeholder="your@email.com" aria-label="Email address for newsletter" />
              <button type="submit">Join</button>
            </form>
          </div>
        </div>

        <div className="footer-bottom">
          <p>Copyright 2026 Orchid Salon & Academy. All rights reserved. Made with care in Bengaluru, India.</p>
          <div className="footer-legal">
            <Link to="/contact">Privacy Policy</Link>
            <Link to="/contact">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
